import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'
import emptyId from '~/statics/empty-id'

const KEYS = {
  Set: 'set',
  Clear: 'clear',
  Update: 'update'
}

export const mutations = {
  [KEYS.Set](state, list) {
    if (list && Array.isArray(list)) {
      state.accounts = list
    } else {
      state.accounts = []
    }
  },

  [KEYS.Clear](state) {
    state.accounts = []
  },
  [KEYS.Update](state, list) {
    for (let account of list) {
      let index = state.accounts.findIndex(c => c.id === account.id)

      if (index > -1)
        state.accounts.splice(index, 1, account)
    }
  },
}

export default {
  namespaced: true,
  state: {
    accounts: []
  },
  mutations,
  actions: {
    async refresh({ dispatch, commit, state, rootGetters }, options) {
      options = _.extend({ force: false }, options)

      var key = 'accounts'

      // if (options.force !== true) {
      //   var cached = await dispatch('cache/get', key, { root: true })

      //   if (cached != null) {
      //     commit(KEYS.Set, cached)
      //     return
      //   }
      // }

      let data = {
        fiscalPeriodId: rootGetters['useraccount/currentUserDetails'].fiscalId
      }
      var result = await post(Endpoints.getUrl('accounts.list'), data, null, { preventConcurrent: false })
      if (result.success) {
        // var cacheObj = {
        //   key,
        //   seconds: 24 * 60 * 60,
        //   value: result.data.items
        // }

        // dispatch('cache/set', cacheObj, { root: true })
        // commit(KEYS.Set, cacheObj.value)
        commit(KEYS.Set, result.data.items)
      }
    },

    set({ commit }, list) {
      commit(KEYS.Set, list)
    },

    clear({ commit }) {
      commit(KEYS.Clear)
    },
  },
  getters: {
    all: state => {
      return state.accounts
    },
    getByCode: state => code => {
      return state.accounts.filter(item => item.accountingCode === code)
    },
    getById: state => id => {
      return state.accounts.find(x => x.id === id)
    },
    getByIds: state => ids => {
      return state.accounts.filter(x => (ids || []).indexOf(x.id) > -1)
    },
    leaves: state => {
      return state.accounts.filter(item => item.hasChild === false)
    },
    getMaxCentersLevel: state => {
      return Math.max(Math.max(...state.accounts.map(o => o.maxCenterLevel)), 1)
    },
    parents: (state, getters) => accountId => {
      let account = getters.getById(accountId)
      if (account == null) {
        return null
      }

      let list = []
      const addParent = item => {
        if (item.parent && item.parent.id !== emptyId) {
          let parent = getters.getById(item.parent.id)
          if (parent) {
            list.push(parent.id)
            addParent(parent)
          }
        }
      }

      addParent(account)
      return list
    },
    getParentByLevel: (state, getters) => (accountId, level) => {
      let account = getters.getById(accountId)
      if (account == null) {
        return null
      }

      let list = []
      const addParent = item => {
        if (item.parent) {
          let parent = getters.getById(item.parent.id)
          if (parent) {
            list.push(parent)
            addParent(parent)
          }
        }
      }

      addParent(account)
      return list.find(x => x.level === level)
    },
    children: (state, getters) => (accountId, takeIds = true) => {
      let list = []
      const addChildren = id => {
        let account = getters.getById(id)
        if (account) {
          for (let child of state.accounts.filter(x => x.parent && x.parent.id === account.id)) {
            list.push(child)
            addChildren(child.id)
          }
        }
      }

      addChildren(accountId)

      if (takeIds) {
        list = list.map(x => x.id)
        list = list.reduce((arr, id) => {
          if (arr.indexOf(id) === -1) {
            arr.push(id)
          }
          return arr
        }, [])
      }

      return list
    },
    isInChildrenTree: (state, getters) => (accountId, scanAccountId) => {
      let children = getters['children'](scanAccountId)
      if (children != null) {
        children.splice(0, 0, scanAccountId)
        return children.findIndex(x => x === accountId) > -1
      } else {
        return false
      }
    }
  }
}
